//This file is automatically rebuilt by the Cesium build process.
export default "float czm_readNonPerspective(float value, float oneOverW) {\n\
return value * oneOverW;\n\
}\n\
vec2 czm_readNonPerspective(vec2 value, float oneOverW) {\n\
return value * oneOverW;\n\
}\n\
vec3 czm_readNonPerspective(vec3 value, float oneOverW) {\n\
return value * oneOverW;\n\
}\n\
vec4 czm_readNonPerspective(vec4 value, float oneOverW) {\n\
return value * oneOverW;\n\
}\n\
";
